import { useDispatch, useSelector } from 'react-redux';
import {
    selectLayout,
    setSelectedMenuKey,
} from '@src/store/layout/layoutSlice';
import { selectCurrentUser } from '@src/store/user/userSlice';
import { useAppTranslate } from '@src/i18n/i18n';

export function useExtractPageTitle() {
    const layout = useSelector(selectLayout);
    const user = useSelector(selectCurrentUser);
    const { t } = useAppTranslate();
    const dispatch = useDispatch();

    function getSectionTitle(): string {
        if (layout.key.key === 'dashboard') {
            if (!user?.name) {
                return t('sidebar.dashboard');
            }
            return t('sidebar.welcome', { name: user?.name });
        }

        return layout.key.label;
    }

    function setPageTitle(key: string) {
        dispatch(
            setSelectedMenuKey({
                key: key,
                label: t(`sidebar.${key}`),
            })
        );
    }

    return {
        getSectionTitle,
        setPageTitle,
        titleKey: layout.key.key,
    };
}
